<template>
  <div>
    <div>
      <!-- Header -->
    </div>
    <router-view />
    <div>
      <!-- Footer -->
    </div>
  </div>
</template>
<script>
  export default {}
</script>
<style lang="scss" scoped></style>
